module.exports = __webpack_public_path__ + "img/37_bohle.7d35feb3.jpeg";